function Index() {
  return (
    <iframe
      src="https://ana.til.kz"
      className="w-full h-full"
      title="Ana tili"
    />
  );
}

export default Index;
